import { i18n } from 'app/utils/i18n';

export function Level({ organization }) {
  const iconClassName = organization ? 'fal fa-user' : 'fal fa-globe';
  const labelKey = organization ? 'theme.level.organization' : 'theme.level.system';
  const background = organization ? 'bg-green-100' : 'bg-blue-300';
  const iconColor = organization ? 'text-green-700' : 'text-blue-800';

  return (
    <div className={`border border-line rounded px-2 py-1 d-flex flex-row align-items-center ${background}`}>
      <span className="text-gray-900">{i18n(labelKey)}</span>
      <span className={`ms-2 ${iconColor}`}>
        <i className={iconClassName}></i>
      </span>
    </div>
  );
}
